import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-paginator-control',
  standalone: true,
  imports: [PaginatorModule],
  template: `
    <p-paginator
      appendTo="body"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [alwaysShow]="alwaysShow"
      [showCurrentPageReport]="showCurrentPageReport"
      currentPageReportTemplate="{first}–{last} de {totalRecords}"
      styleClass="sp-paginator"
      (onPageChange)="pageChange.emit($event)"
    />
  `,
})
export class PaginatorControlComponent {
  @Input() first = 0;
  @Input() rows = 10;
  @Input() totalRecords = 0;
  @Input() rowsPerPageOptions: number[] = [10, 20, 50];
  @Input() alwaysShow = true;
  @Input() showCurrentPageReport = false;

  @Output() pageChange = new EventEmitter<PaginatorState>();
}
